


import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Modal } from 'react-bootstrap';
import Breadcrumb from "app/components/Breadcrumb";
import 'react-datepicker/dist/react-datepicker.css';
import './notificationcss/NotificationForm.css'
import useTranslations from '../transalation/TranslationUtils';
import { clearEditPush, createPush, deletePush, getPushDetail, publishPush, setCreateLoading, setPushSimpleData, setPushSimpleDataToPushData, updatePush, uploadPushImage, withdrawPush } from 'app/redux/slices/rdxPushSlice';
import { DEFAULT_IP, MODE_ADD, MODE_EDIT, MODE_UNKNOWN } from 'app/utils/constant';
import { useLocation, useNavigate } from 'react-router-dom';
import CancelIcon from '@mui/icons-material/Cancel';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { CKEditor } from "ckeditor4-react";
import LabelDiv from 'app/components/LabelDiv';
import axios from 'axios';
import { cmnFormatDate } from 'app/utils/utils';
import { Close } from '@mui/icons-material';

const NotificationForm = () => {

  const custom_config = {
    removePlugins: 'elementspath, scayt, uploadimage, image2, image, filebrowser, uploadfile, link',
    scayt_autoStartup: false,
    toolbarCanCollapse: true,
    extraPlugins: ['emoji'],
    toolbar: [
      { name: 'clipboard', items: ['Undo', 'Redo'] },
      { name: 'editing', items: ['Replace', '-', 'SelectAll'] },
      { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', 'RemoveFormat'] },
      { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] },
      { name: 'links', items: ['EmojiPanel'] },
      { name: 'insert', items: ['Table', 'HorizontalRule', 'SpecialChar'] },
      { name: 'styles', items: ['Format', 'Font', 'FontSize'] },
      { name: 'colors', items: ['TextColor', 'BGColor'] }
    ],
    // Disable all file upload and browsing capabilities
    uploadUrl: "",
    filebrowserBrowseUrl: "",
    filebrowserImageBrowseUrl: "",
    filebrowserUploadUrl: "",
    filebrowserImageUploadUrl: "",
    // Disable image-related features
    disableNativeSpellChecker: false,
    allowedContent: true,
    // Remove image-related styles
    stylesSet: []
  }

  const { title,
    subtitle,
    messageContent,
    sendDateTime,
    preview,
    test,
    scheduleAt,
    now,
    targetAudience,
    allAppUsers,
    paidUsersOnly,
    guestOnly,
    confirm,
    withdraw, pushNotifications, pushnotiification, addPhotoVideo, role_Add, role_delete, usersearch, save, cancel,
    showErrMsg, showSuccessMsg, mEdit, mAdd, i18nObj, i18nObj2,
    uploadPhotoVideo, imageFileOnly,
    linkButtonName, linkButtonUrl, 
    linkButtonNameEn, linkButtonUrlEn, 
    mobile,
    mFreeUser2, mPaidUser2,
    confirmPushPublish,
    confirmPushWithdraw,
    createDraft, saveDraft } = useTranslations();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [testPhoneNum, setTestPhoneNum] = useState("");
  const [breadCrumbInit, setBreadCrumbInit] = useState(false);
  const [isUploadMediaModalOpen, setIsUploadMediaModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [showInlineEdit, setShowInlineEdit] = useState(false);

  const pushEditMode = useSelector((state) => state.rdxPush?.pushEditMode || MODE_UNKNOWN);
  const pushEditData = useSelector((state) => state.rdxPush?.pushEditData || {});
  const pushInfo = useSelector((state) => state.rdxPush?.pushInfo || {});
  const pushAuditOptions = useSelector((state) => state.rdxMain?.pushAuditOptions || []);
  const audienceIdMap = useSelector((state) => state.rdxMain?.audienceIdMap || {});

  useEffect(() => {
    // Component mount logic
    const searchParams = new URLSearchParams(location.search);
    const pushId = searchParams.get("push_id");

    dispatch(getPushDetail(pushId, (isSuccess, data) => {
      if (!isSuccess) {
        alert(showErrMsg(data));
        navigate("/pushnotification");
      }
    }));

    // dispatch(otherCommonData());

    return () => {
      // Component unmount logic
      dispatch(clearEditPush())
    };
  }, []);

  useEffect(() => {
    // Component mount logic
    if (MODE_EDIT == pushEditMode || MODE_ADD == pushEditMode) {
      setBreadCrumbInit(true);
    }
  }, [pushEditMode]);

  const initialTags = ['Senior', 'Pre-Senior', 'Volunteer', 'Caregiver', 'Instructor'];

  // State for visible tags
  const [visibleTags, setVisibleTags] = useState(initialTags);

  // Load tags from localStorage on component mount
  useEffect(() => {
    const storedTags = JSON.parse(localStorage.getItem('visibleTags'));
    if (storedTags) {
      setVisibleTags(storedTags);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('visibleTags', JSON.stringify(initialTags));
  }, []);


  // Handle removing a tag
  const removeTag = (tag) => {
    const updatedTags = visibleTags.filter((t) => t !== tag);
    setVisibleTags(updatedTags);
    localStorage.setItem('visibleTags', JSON.stringify(updatedTags)); // Update localStorage
  };

  const isVideoFile = (filename) => {
    const videoExtensions = ['mp4', 'webm', 'ogg', 'avi', 'mov', 'mkv', 'flv', 'wmv', '3gp'];
    const extension = filename.split('.').pop().toLowerCase();
    return videoExtensions.includes(extension);
  }

  const handleChange = (e, path) => {
    const { value } = e.target;

    let pass = false;
    let formatVal = undefined;

    if ("push_date" === path) {
      formatVal = new Date(`${value}:00+08:00`).getTime() / 1000;
      pass = true;
    } else if ("time_option" === path || "push_target" === path) {
      formatVal = parseInt(value);
      pass = true;
    } else {
      formatVal = value;
      pass = true;
    }

    if (pass) {
      let data = {
        data: formatVal,
        projection: "pushEditData",
        path: path
      }
      dispatch(setPushSimpleData(data));
    }
  };

  const handleSave = async () => {
    // const isValid = validateForm();
    // if (!isValid) {
    //   return;
    // }

    if (MODE_EDIT === pushEditMode) {
      dispatch(updatePush(pushEditData, (isSuccess, data) => {
        if (isSuccess) {
          let rData = {
            data: pushEditData,
            projection: "self",
            base: pushInfo
          };
          dispatch(setPushSimpleDataToPushData(rData));
          alert("Push updated successfully!");
        } else {
          alert(showErrMsg(data));
        }
      }));
    } else {
      dispatch(setCreateLoading({ loading: true }));
      dispatch(createPush(pushEditData, (isSuccess, data) => {
        if (isSuccess) {
          alert("Push create successfully!");
          
          // Instead of navigating away, switch to inline edit mode
          if (data.data && data.data.push_id) {
            // Update the edit data with the new push_id
            let updateData = {
              data: data.data.push_id,
              projection: "pushEditData",
              path: "push_id"
            };
            dispatch(setPushSimpleData(updateData));
            
            // Switch the interface to edit mode without navigation
            setShowInlineEdit(true);
            
            // Simulate getting the push detail for the newly created push
            dispatch(getPushDetail(data.data.push_id, (isSuccess, detailData) => {
              if (!isSuccess) {
                alert(showErrMsg(detailData));
              }
            }));
          } else {
            setShowInlineEdit(true);
          }
          
          dispatch(setCreateLoading({ loading: false }));
        } else {
          dispatch(setCreateLoading({ loading: false }));
          alert(showErrMsg(data));
        }
      }));
    }
  };


  const showUploadMediaModal = () => {
    setIsUploadMediaModalOpen(true);
  }

  const closeUploadMediaModal = () => {
    setIsUploadMediaModalOpen(false);
    setSelectedFile(null);
    setPreviewUrl(null);
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    setSelectedFile(file);
    setPreviewUrl(URL.createObjectURL(file));
  };

  const handleSaveMedia = async () => {
    dispatch(uploadPushImage(selectedFile, (imgUrl, msg) => {
      if (imgUrl) {
        let data = {
          data: imgUrl,
          projection: "pushEditData",
          path: "push_medias"
        }
        dispatch(setPushSimpleData(data));
        closeUploadMediaModal();
      } else {
        alert(msg);
      }
    }));
  }

  const handleDelete = async () => {
    if (window.confirm(`Are you sure you want to delete "${i18nObj2(pushEditData, "title")}"?`)) {
      dispatch(deletePush({ "push_id": pushEditData.push_id }, (isSuccess, data) => {
        if (isSuccess) {
          alert("Notification deleted successful!");
          navigate("/pushnotification");
        } else {
          alert(showErrMsg(data));
        }
      }));
    }
  }

  const onPublishPushClick = async () => {
    if (window.confirm(confirmPushPublish() + " " + i18nObj2(pushEditData, "title") + "?")) {
      
      // Step 1: First save the draft automatically
      const saveFirst = () => {
        return new Promise((resolve) => {
          if (MODE_EDIT == pushEditMode || showInlineEdit) {
            // For edit mode, update the existing push
            dispatch(updatePush(pushEditData, (isSuccess, data) => {
              if (isSuccess) {
                let rData = {
                  data: pushEditData,
                  projection: "self",
                  base: pushInfo
                };
                dispatch(setPushSimpleDataToPushData(rData));
                resolve({ success: true, message: "Push updated successfully!" });
              } else {
                resolve({ success: false, error: data });
              }
            }));
          } else {
            // For add mode, create the push first
            dispatch(setCreateLoading({ loading: true }));
            dispatch(createPush(pushEditData, (isSuccess, data) => {
              dispatch(setCreateLoading({ loading: false }));
              if (isSuccess && data.data && data.data.push_id) {
                // Update the edit data with the new push_id for publishing
                let updateData = {
                  data: data.data.push_id,
                  projection: "pushEditData", 
                  path: "push_id"
                };
                dispatch(setPushSimpleData(updateData));
                resolve({ success: true, message: "Push created successfully!", push_id: data.data.push_id });
              } else {
                resolve({ success: false, error: data });
              }
            }));
          }
        });
      };

      // Execute save first
      const saveResult = await saveFirst();
      
      if (!saveResult.success) {
        alert("Failed to save draft: " + showErrMsg(saveResult.error));
        return;
      }

      // Step 2: If save successful, proceed with publish
      const pushIdToPublish = saveResult.push_id || pushEditData.push_id;
      
      dispatch(publishPush({ "push_id": pushIdToPublish }, (isSuccess, data) => {
        if (isSuccess) {
          alert(showSuccessMsg(data));
          // Step 3: Redirect to push notification list after successful publish
          navigate("/pushnotification");
        } else {
          alert("Failed to publish: " + showErrMsg(data));
        }
      }));
    }
  }

  const onWithdrawPushClick = async () => {
    if (window.confirm(confirmPushWithdraw() + " " + i18nObj2(pushEditData, "title") + "?")) {
      dispatch(withdrawPush({ "push_id": pushEditData.push_id }, (isSuccess, data) => {
        if (isSuccess) {
          alert(showSuccessMsg(data));
        } else {
          alert(showErrMsg(data));
        }
      }));
    }
  }

  const handleCkEditroReady = (evt) => {
    const editor = evt.editor;

    // Completely disable any file upload or browsing functionality
    editor.on('fileUploadRequest', function (evt) {
      evt.stop(); // prevent any upload request
      evt.cancel(); // cancel the upload
      alert('Image upload is disabled for security reasons.');
    });

    editor.on('fileUploadResponse', function (evt) {
      evt.stop(); // prevent any upload response
      evt.cancel(); // cancel the response
    });

    // Disable any drag and drop functionality for files
    editor.on('contentDom', function() {
      const editable = editor.editable();
      editable.attachListener(editable, 'drop', function(evt) {
        const dataTransfer = evt.data.$.dataTransfer;
        if (dataTransfer && dataTransfer.files && dataTransfer.files.length > 0) {
          evt.data.preventDefault();
          alert('File uploads are not allowed.');
        }
      });
    });
  };

  const onCkEditorContentChanged = (event, key) => {
    let data = {
      data: event.editor.getData(),
      projection: "pushEditData",
      path: key
    }
    dispatch(setPushSimpleData(data));
  }

  const onTestPushClick = async () => {
    //TODO peteryeh 待跟 Leo 確認正確 API payload
    const postRes = await axios.post(DEFAULT_IP + "/webapp/memportal/testpush", {
      push_id: pushEditData.push_id,
      account_phone: testPhoneNum,
      push_type: "market_push"
    });
    let data = postRes.data;

    if (1 === data?.code) {
      alert(showSuccessMsg(data));
    } else {
      alert(showErrMsg(data));
    }
  }

  const onAddPushTag = (item) => {
    let newRows = [...pushEditData.push_tags];
    newRows.push(item.audience_id);

    let data = {
      data: newRows,
      projection: "pushEditData",
      path: "push_tags"
    };
    dispatch(setPushSimpleData(data));
  }

  const onRemovePushTag = (item) => {
    let index = pushEditData.push_tags?.indexOf(item);
    if (index !== -1) {
      let newRows = [...pushEditData.push_tags];
      newRows.splice(index, 1);

      let data = {
        data: newRows,
        projection: "pushEditData",
        path: "push_tags"
      };
      dispatch(setPushSimpleData(data));
    }
  }

  const isReadOnly = () => {
    return pushEditData.push_status == 3;
  }

  const cantChangeTime = () => {
    return pushEditData.push_status == 2;
  }

  return (
    <div className="container">
      <div className="mt-4 ms-4 me-4">
        {(!breadCrumbInit) ? (
          <React.Fragment></React.Fragment>
        ) : (
          <div className="breadcrumb">
            {(MODE_EDIT == pushEditMode) ? (
              <Breadcrumb firstSegName={mEdit()} routeSegments={[{ name: pushnotiification(), path: "/pushnotification" }, { name: mEdit() + " (" + i18nObj2(pushInfo, "title") + ")" }]} />
            ) : (
              <Breadcrumb routeSegments={[{ name: pushnotiification(), path: "/pushnotification" }, { name: mAdd() }]} />
            )}
          </div>
        )}

        <Form>
          {isReadOnly() && (
            <div style={{
              "left": "0px",
              "top": "60px",
              "width": "100%",
              "height": "100%",
              "position": "absolute",
              "background": "#ffffff77",
              "zIndex": 10
            }}></div>
          )}
          {pushEditData.push_medias && (
            <Row xs="auto" className="d-flex justify-content-center mt-2">
              <Col>
                {isVideoFile(pushEditData.push_medias) ? (
                  <video style={{ width: '100%', maxWidth: '400px' }} controls>
                    <source src={pushEditData.push_medias} />
                  </video>
                ) : (
                  <img src={pushEditData.push_medias} style={{ width: '100%', maxWidth: '400px' }} />
                )}
                <CancelIcon
                  color="error" size="large"
                  sx={{
                    fontSize: 36, cursor: "pointer", position: "absolute", marginLeft: "-16px", marginTop: "-20px"
                  }}
                  onClick={() => handleChange({ target: { value: "" } }, "push_medias")} />
              </Col>
            </Row>
          )}
          <div className="d-flex justify-content-center mt-3 mb-3">
            <Button variant="primary" onClick={showUploadMediaModal} className='addphotobtn'>
              {pushEditData.push_medias && (uploadPhotoVideo())}
              {!pushEditData.push_medias && (addPhotoVideo())}
            </Button>
          </div>

          {/* Titles and Subtitles Section */}
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="titleChinese" className="floating-label-group">
                <Form.Control
                  type="text"
                  className="floating-input"
                  name="titleChinese"
                  value={pushEditData.title_zh}
                  onChange={(e) => handleChange(e, "title_zh")}
                  required  // Required field
                />
                <Form.Label className="floating-label">{title()}</Form.Label>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="titleEnglish" className="floating-label-group">
                <Form.Control
                  type="text"
                  className="floating-input"
                  name="titleEnglish"
                  value={pushEditData.title_en}
                  onChange={(e) => handleChange(e, "title_en")}
                  required  // Required field
                />
                <Form.Label className="floating-label">Title (English)</Form.Label>
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="subtitleChinese" className="floating-label-group">
                <Form.Control
                  type="text"
                  className="floating-input"
                  name="subtitleChinese"
                  value={pushEditData.subtitle_zh}
                  onChange={(e) => handleChange(e, "subtitle_zh")}
                  required  // Required field
                />
                <Form.Label className="floating-label">{subtitle()}</Form.Label>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="subtitleEnglish" className="floating-label-group">
                <Form.Control
                  type="text"
                  className="floating-input"
                  name="subtitleEnglish"
                  value={pushEditData.subtitle_en}
                  onChange={(e) => handleChange(e, "subtitle_en")}
                  required  // Required field
                />
                <Form.Label className="floating-label">Subtitle (English)</Form.Label>
              </Form.Group>
            </Col>
          </Row>

          {/* Message Content Section */}
          <Row className="mb-4">
            <Col md={6}>
              <LabelDiv>{messageContent()}</LabelDiv>
              {(MODE_ADD == pushEditMode || MODE_EDIT == pushEditMode) && (
                <CKEditor
                  editorUrl="/assets/js/ckeditor/ckeditor.js"
                  initData={pushEditData.message_zh}
                  config={custom_config}
                  onChange={(event) => {
                    onCkEditorContentChanged(event, "message_zh");
                  }}
                  onInstanceReady={handleCkEditroReady}
                />
              )}
              {/* <Form.Group controlId="messageChinese" className="floating-label-group">
              <Form.Control
                as="textarea"
                rows={3}
                className="floating-input"
                name="messageChinese"
                value={pushEditData.message_zh}
                onChange={(e) => handleChange(e, "message_zh")}
                style={{ height: '100px' }}
                required  // Required field
              />
              <Form.Label className="floating-label">{messageContent()}</Form.Label>
            </Form.Group> */}
            </Col>
            <Col md={6}>
              <LabelDiv>Message Content (English)</LabelDiv>
              {(MODE_ADD == pushEditMode || MODE_EDIT == pushEditMode) && (
                <CKEditor
                  editorUrl="/assets/js/ckeditor/ckeditor.js"
                  initData={pushEditData.message_en}
                  config={custom_config}
                  onChange={(event) => {
                    onCkEditorContentChanged(event, "message_en");
                  }}
                  onInstanceReady={handleCkEditroReady}
                />
              )}
              {/* <Form.Group controlId="messageEnglish" className="floating-label-group">
              <Form.Control
                as="textarea"
                rows={3}
                className="floating-input"
                name="messageEnglish"
                value={pushEditData.message_en}
                onChange={(e) => handleChange(e, "message_en")}
                style={{ height: '100px' }}
                required  // Required field
              />
              <Form.Label className="floating-label">Message Content (English)</Form.Label>
            </Form.Group> */}
            </Col>
          </Row>

          {/* Link Button Section */}
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="linkBtnName" className="floating-label-group-ph">
                <Form.Control
                  type="text"
                  className="floating-input-ph"
                  name="linkBtnName"
                  value={pushEditData.action_text}
                  onChange={(e) => handleChange(e, "action_text")}
                  placeholder="in the field, enter the subject name"
                />
                <Form.Label className="floating-label-ph">{linkButtonName()}</Form.Label>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="linkBtnUrl" className="floating-label-group-ph">
                <Form.Control
                  type="text"
                  className="floating-input-ph"
                  name="linkBtnUrl"
                  value={pushEditData.action_url}
                  onChange={(e) => handleChange(e, "action_url")}
                  placeholder="in the field, enter your subject url"
                />
                <Form.Label className="floating-label-ph">{linkButtonUrl()}</Form.Label>
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="linkBtnName" className="floating-label-group-ph">
                <Form.Control
                  type="text"
                  className="floating-input-ph"
                  name="linkBtnNameEn"
                  value={pushEditData.action_text_en}
                  onChange={(e) => handleChange(e, "action_text_en")}
                  placeholder="in the field, enter the subject name"
                />
                <Form.Label className="floating-label-ph">{linkButtonNameEn()}</Form.Label>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="linkBtnUrl" className="floating-label-group-ph">
                <Form.Control
                  type="text"
                  className="floating-input-ph"
                  name="linkBtnUrlEn"
                  value={pushEditData.action_url_en}
                  onChange={(e) => handleChange(e, "action_url_en")}
                  placeholder="in the field, enter your subject url"
                />
                <Form.Label className="floating-label-ph">{linkButtonUrlEn()}</Form.Label>
              </Form.Group>
            </Col>
          </Row>

          {/* Preview Section - Show in edit mode OR after inline creation */}
          {(MODE_EDIT === pushEditMode || showInlineEdit) && (
            <Row className="mt-5">
              <Col xs={12}>
                <h5 className='notificationdatetime'>{preview()}</h5>
              </Col>

              <Col xs={12} className="d-flex flex-wrap flex-row align-items-center">
                <Form.Group controlId="testPhoneNum" className="floating-label-group me-2" style={{ width: "230px" }}>
                  <Form.Control
                    type="text"
                    className="floating-input"
                    name="testPhoneNum"
                    value={testPhoneNum}
                    onChange={e => {
                      // Ensure mobile are numeric and max 8 digits
                      if (/^\d{0,8}$/.test(e.target.value)) {
                        setTestPhoneNum(e.target.value);
                      }
                    }}
                  />
                  <Form.Label className="floating-label">{mobile()}</Form.Label>
                </Form.Group>
                <Button variant="" className="testbtn" onClick={onTestPushClick} >
                  {test()}
                </Button>
              </Col>
            </Row>
          )}


          {/* Send Date & Time Section */}
          <Row className="mt-5">
            <Col md={5}>
              <h5 className='notificationdatetime'>{sendDateTime()}</h5>
              <Row>
                <Col xs={12} className="mt-3">
                  <Form.Check
                    disabled={(cantChangeTime()) ? true : false}
                    type="radio"
                    label={now()}
                    name="sendTimeOptions"
                    className="mt-2previewcheck"
                    value={1}
                    checked={1 == pushEditData.time_option}
                    onChange={(e) => handleChange(e, "time_option")}
                  />
                </Col>
                <Col xs={12} className="mt-2 d-flex flex-wrap flex-row align-items-center">
                  <Form.Check
                    disabled={(cantChangeTime()) ? true : false}
                    type="radio"
                    label={scheduleAt()}
                    name="sendTimeOptions"
                    className="mt-1 me-2 spreviewcheck"
                    value={2}
                    checked={2 == pushEditData.time_option}
                    onChange={(e) => handleChange(e, "time_option")}
                  />
                  <Form.Control
                    disabled={(cantChangeTime()) ? true : false}
                    type="datetime-local"
                    placeholder="Select Date"
                    className='datetimelogin'
                    value={cmnFormatDate(pushEditData.push_date, "datetime2")}
                    onChange={e => handleChange(e, "push_date")}  // Update startDate
                  />
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className="mt-5">
            <Col md={5}>
              <h5 className="targethead">{targetAudience()}</h5>
              <Form.Check
                type="radio"
                label={allAppUsers()}
                name="audienceOptions"
                className="mt-3 previewcheck"
                value={1}
                checked={1 == pushEditData.push_target}
                onChange={(e) => handleChange(e, "push_target")}
              />
              <Form.Check
                type="radio"
                label={mPaidUser2()}
                name="audienceOptions"
                className="mt-2 previewcheck"
                value={2}
                checked={2 == pushEditData.push_target}
                onChange={(e) => handleChange(e, "push_target")}
              />
              <Form.Check
                type="radio"
                label={mFreeUser2()}
                name="audienceOptions"
                className="mt-2 previewcheck"
                value={3}
                checked={3 == pushEditData.push_target}
                onChange={(e) => handleChange(e, "push_target")}
              />
            </Col>
          </Row>

          <Row className="mt-2">
            <Col xs={12}>
              {pushAuditOptions && (
                <React.Fragment>
                  {pushAuditOptions.map((item, index) => (
                    <Button className="m-1" key={index} variant="outline-primary" disabled={pushEditData.push_tags?.includes(item.audience_id)}
                      onClick={() => onAddPushTag(item)}
                    >{i18nObj(item.audience_name)}</Button>
                  ))}
                </React.Fragment>
              )}
            </Col>

            {pushEditData.push_tags && (
              <Col xs={13} className="d-flex mt-2 flex-wrap">
                {pushEditData.push_tags.map((item, index) => (
                  <div key={index} className="me-2">
                    <Button className="m-1" variant="primary"
                      onClick={() => onRemovePushTag(item)}
                    >{i18nObj(audienceIdMap[item]?.audience_name)}</Button>
                    <Close style={{ "cursor": "pointer" }}
                      onClick={() => onRemovePushTag(item)}></Close>
                  </div>
                ))}
              </Col>
            )}
          </Row>

          <Row className="mb-3 mt-4">
            <Col xs={12}>
              {/* Show Create Draft button only when not in edit mode and not in inline edit mode */}
              {(MODE_EDIT != pushEditMode && !showInlineEdit) && (
                <Button variant="" className='submitbutton notificationsave me-2' onClick={handleSave}
                  disabled={MODE_UNKNOWN == pushEditMode}>{createDraft()}</Button>
              )}

              {/* Show edit mode buttons OR inline edit mode buttons */}
              {(MODE_EDIT == pushEditMode || showInlineEdit) && (
                <React.Fragment>
                  {/* For inline edit mode (after create draft), show all available actions */}
                  {showInlineEdit && (
                    <React.Fragment>
                      <Button variant="" className='submitbutton notificationsave me-2' onClick={handleSave}>{saveDraft()}</Button>
                      <Button variant="" className='notificationdelete me-2' onClick={handleDelete}>{role_delete()}</Button>
                      <Button variant="" className='notificationconf me-2' onClick={onPublishPushClick}>{confirm()}</Button>
                      <Button variant="" className='notificationdelete' onClick={onWithdrawPushClick}>{withdraw()}</Button>
                    </React.Fragment>
                  )}
                  
                  {/* For traditional edit mode, show status-based buttons */}
                  {(MODE_EDIT == pushEditMode && !showInlineEdit) && (
                    <React.Fragment>
                      {(0 == pushInfo?.push_status) && (
                        <React.Fragment>
                          <Button variant="" className='submitbutton notificationsave me-2' onClick={handleSave}>{saveDraft()}</Button>
                          <Button variant="" className='notificationdelete me-2' onClick={handleDelete}>{role_delete()}</Button>
                          <Button variant="" className='notificationconf me-2' onClick={onPublishPushClick}>{confirm()}</Button>
                          <Button variant="" className='notificationdelete' onClick={onWithdrawPushClick}>{withdraw()}</Button>
                        </React.Fragment>
                      )}
                      {(1 == pushInfo?.push_status) && (
                        <React.Fragment>
                          <Button variant="" className='submitbutton notificationsave me-2' onClick={handleSave}>{saveDraft()}</Button>
                          {/* <Button variant="" className='notificationdelete me-2' onClick={handleDelete}>{role_delete()}</Button> */}
                          {/* <Button variant="" className='notificationconf me-2' onClick={onPublishPushClick}>{confirm()}</Button> */}
                          <Button variant="" className='notificationdelete' onClick={onWithdrawPushClick}>{withdraw()}</Button>
                        </React.Fragment>
                      )}
                      {(2 == pushInfo?.push_status) && (
                        <React.Fragment>
                          <Button variant="" className='submitbutton notificationsave me-2' onClick={handleSave}>{saveDraft()}</Button>
                          {/* <Button variant="" className='notificationdelete me-2' onClick={handleDelete}>{role_delete()}</Button> */}
                          {/* <Button variant="" className='notificationconf me-2' onClick={onPublishPushClick}>{confirm()}</Button> */}
                          {/* <Button variant="" className='notificationdelete' onClick={onWithdrawPushClick}>{withdraw()}</Button> */}
                        </React.Fragment>
                      )}
                      {(3 == pushInfo?.push_status) && (
                        <React.Fragment>
                          {/* <Button variant="" className='submitbutton notificationsave me-2' onClick={handleSave}>{saveDraft()}</Button> */}
                          {/* <Button variant="" className='notificationdelete me-2' onClick={handleDelete}>{role_delete()}</Button> */}
                          {/* <Button variant="" className='notificationconf me-2' onClick={onPublishPushClick}>{confirm()}</Button> */}
                          {/* <Button variant="" className='notificationdelete' onClick={onWithdrawPushClick}>{withdraw()}</Button> */}
                        </React.Fragment>
                      )}
                    </React.Fragment>
                  )}
                </React.Fragment>
              )}

              {/* {!pushInfo?.push_status && (
                <React.Fragment>
                  <Button variant="" className='submitbutton notificationsave me-2'
                    onClick={handleSave}
                    disabled={MODE_UNKNOWN == pushEditMode}>
                    {(MODE_EDIT == pushEditMode && saveDraft())}
                    {(MODE_EDIT != pushEditMode && createDraft())}
                  </Button>
                  {MODE_EDIT == pushEditMode && (
                    <Button variant="" className='notificationdelete me-2' onClick={handleDelete}>{role_delete()}</Button>
                  )}
                </React.Fragment>
              )}

              {(MODE_EDIT == pushEditMode && 3 != pushInfo?.push_status) && (
                <React.Fragment>
                  <Button variant="" className='notificationconf me-2' onClick={onPublishPushClick}>{confirm()}</Button>
                </React.Fragment>
              )}

              {(MODE_EDIT == pushEditMode && !(!pushInfo?.push_status || 3 == pushInfo?.push_status)) && (
                <React.Fragment>
                  <Button variant="" className='notificationdelete' onClick={onWithdrawPushClick}>{withdraw()}</Button>
                </React.Fragment>
              )} */}
            </Col>
          </Row>
        </Form>

        <Modal show={isUploadMediaModalOpen} onHide={closeUploadMediaModal} centered size="lg" className="custom-modal">
          <Modal.Body style={{ height: '460px' }}>
            <h4 className="maintitle">
              {pushEditData.push_medias && (uploadPhotoVideo())}
              {!pushEditData.push_medias && (addPhotoVideo())}
            </h4>
            <div style={{ textAlign: 'center', height: '156px', padding: '40px', margin: '20px', border: '1px solid #D9D9D9' }}>
              <p>Ratio limit 79:82,format PNG/JPG, e.g. 395(W) * 410(H)</p>
              <Form.Group controlId="formFile">
                <input
                  type="file"
                  id="file-input"
                  accept="image/*,video/*"
                  onChange={handleFileChange}
                  style={{ display: 'none' }}
                />
                <Button onClick={() => document.getElementById('file-input').click()}>Select</Button>
              </Form.Group>
            </div>

            {/* Activity Icon Preview*/}
            {previewUrl && selectedFile && (
              (selectedFile.type.startsWith('image/')) ? (
                <img src={previewUrl} alt="Push Image Preview" style={{ width: '100%', maxHeight: "200px", objectFit: "contain" }} />
              ) : (
                <video alt="Push Video Preview" style={{ width: '100%', maxHeight: "200px" }} controls>
                  <source src={previewUrl} />
                </video>
              )
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={closeUploadMediaModal}>
              {cancel()}
            </Button>
            <Button variant="primary" onClick={handleSaveMedia} disabled={!selectedFile}>
              {save()}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default NotificationForm;